/**
 * ╔══════════════════════════════════════════════════════════════╗
 * ║   Quick Add to Cart — v3                                   ║
 * ║   Fixes: hover-only on desktop, image-area position,      ║
 * ║          cart icon matches header bag icon                 ║
 * ║                                                            ║
 * ║   Install: assets/quick-add.js                            ║
 * ║   Load:   {{ 'quick-add.js' | asset_url | script_tag }}   ║
 * ║           (paste above </body> in theme.liquid)           ║
 * ╚══════════════════════════════════════════════════════════════╝
 */

(function () {
  'use strict';

  var CFG = {
    currencySymbol:    '$',
    successResetDelay: 1800,
  };

  /* ── SELECTORS ──
     CARD_SEL  : the outer wrapper (used for hover trigger)
     INNER_SEL : the image-only container — button injects here
                 so it overlays the photo, not the title area     */
  var CARD_SEL  = '.card-wrapper, .product-card-wrapper';
  var INNER_SEL = '.card__inner';   /* Dawn's image+ratio container */

  /* ── BAG + PLUS SVG (card button icon) ──
     FIX v3.1: added width="18" height="18" so the icon renders
     on mobile (without explicit dimensions the SVG collapses).  */
  var BAG_PLUS_SVG = [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28"',
    ' width="18" height="18"',   /* ← THE FIX: was missing these */
    ' fill="none" stroke="currentColor" stroke-width="1.6"',
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">',
    /* Left side — full */
    '<line x1="4" y1="8" x2="4" y2="21"/>',
    /* Top edge */
    '<line x1="4" y1="8" x2="21" y2="8"/>',
    /* Right side — top half only, stops halfway */
    '<line x1="21" y1="8" x2="21" y2="14"/>',
    /* Handle arch */
    '<path d="M9,8 C9,4.5 16,4.5 16,8"/>',
    /* Plus vertical — drops from where right side stopped */
    '<line x1="21" y1="13" x2="21" y2="25"/>',
    /* Plus horizontal */
    '<line x1="15" y1="19" x2="27" y2="19"/>',
    '</svg>',
  ].join('');

  /* ── CHECK SVG (success state) ── */
  var CHECK_SVG = [
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"',
    ' stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"',
    ' width="16" height="16" aria-hidden="true">',
    '<polyline points="20 6 9 17 4 12"/>',
    '</svg>',
  ].join('');

  /* ── MODAL ADD TO CART ICON — same bag+plus treatment ── */
  var HEADER_BAG_SVG = [
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28"',
    ' fill="none" stroke="currentColor" stroke-width="1.8"',
    ' stroke-linecap="round" stroke-linejoin="round"',
    ' width="18" height="18" aria-hidden="true">',
    '<line x1="4" y1="8" x2="4" y2="21"/>',
    '<line x1="4" y1="8" x2="21" y2="8"/>',
    '<line x1="21" y1="8" x2="21" y2="14"/>',
    '<path d="M9,8 C9,4.5 16,4.5 16,8"/>',
    '<line x1="21" y1="13" x2="21" y2="25"/>',
    '<line x1="15" y1="19" x2="27" y2="19"/>',
    '</svg>',
  ].join('');

  /* ════════════════════════════════════════════════════════════
     STYLES
  ════════════════════════════════════════════════════════════ */
  function injectStyles() {
    if (document.getElementById('qa-styles')) return;
    var s = document.createElement('style');
    s.id = 'qa-styles';
    s.textContent = [

      /* ── Button wrapper ──
         Positioned inside .card__inner (the image area).
         Hidden by default; revealed on .card-wrapper hover.     */
      '.qa-btn-wrap{',
        'position:absolute;',
        'bottom:10px;right:10px;',
        'z-index:30;',
        'pointer-events:none;',
        'display:flex;align-items:center;justify-content:flex-end;',
        /* Hidden by default on desktop */
        'opacity:0;',
        'transform:translateY(4px);',
        'transition:opacity 250ms ease, transform 250ms ease;',
      '}',

      /* Reveal on card hover (desktop) */
      '.card-wrapper:hover .qa-btn-wrap,',
      '.product-card-wrapper:hover .qa-btn-wrap{',
        'opacity:1;',
        'transform:translateY(0);',
        'pointer-events:auto;',
      '}',

      /* Always visible on touch devices */
      '@media(hover:none){',
        '.qa-btn-wrap{opacity:1;transform:translateY(0);pointer-events:auto;}',
      '}',

      /* ── Pill button ── */
      '.qa-btn{',
        'pointer-events:auto;',
        'display:inline-flex;align-items:center;gap:7px;',
        'padding:0 10px;height:38px;',
        'background:#fff;',
        'border:1.8px solid rgba(190,168,130,0.55);',
        'border-radius:100px;',
        'cursor:pointer;',
        'font-family:inherit;font-size:11px;font-weight:600;',
        'letter-spacing:0.1em;text-transform:uppercase;color:#111;',
        'white-space:nowrap;overflow:hidden;',
        'max-width:38px;',
        'transition:',
          'max-width 350ms cubic-bezier(0.4,0,0.2,1),',
          'padding 350ms cubic-bezier(0.4,0,0.2,1),',
          'border-color 250ms ease,',
          'box-shadow 250ms ease,',
          'background 200ms ease;',
        'will-change:max-width;',
        'box-shadow:0 1px 8px rgba(0,0,0,0.1);',
        'user-select:none;-webkit-user-select:none;',
      '}',

      '.qa-btn__icon{',
        'width:18px;height:18px;flex-shrink:0;',
        'display:flex;align-items:center;justify-content:center;color:#111;',
      '}',

      '.qa-btn__label{',
        'opacity:0;transform:translateX(-4px);',
        'transition:opacity 250ms ease 80ms,transform 250ms ease 80ms;',
        'pointer-events:none;color:#111;',
      '}',

      /* Expanded state */
      '.qa-btn:hover,.qa-btn.expanded{',
        'max-width:140px;padding:0 14px;',
        'border-color:rgba(190,168,130,0.9);',
        'box-shadow:0 2px 14px rgba(0,0,0,0.13);',
      '}',
      '.qa-btn:hover .qa-btn__label,.qa-btn.expanded .qa-btn__label{',
        'opacity:1;transform:translateX(0);',
      '}',

      /* Success state */
      '.qa-btn.qa-success{',
        'max-width:140px;padding:0 14px;',
        'background:#111;border-color:#111;',
      '}',
      '.qa-btn.qa-success .qa-btn__icon{color:#fff;}',
      '.qa-btn.qa-success .qa-btn__label{opacity:1;transform:translateX(0);color:#fff;}',

      /* .card__inner must be relative for absolute positioning to work */
      '.card__inner{position:relative !important;}',

      /* ════════════════════════════════════════════════════════
         MODAL
      ════════════════════════════════════════════════════════ */
      '#qa-overlay{',
        'position:fixed;inset:0;',
        'background:rgba(0,0,0,0.52);',
        'z-index:9998;',
        'display:flex;align-items:center;justify-content:center;',
        'padding:20px;',
        'opacity:0;visibility:hidden;',
        'transition:opacity 300ms ease,visibility 300ms ease;',
        'backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);',
      '}',
      '#qa-overlay.qa-open{opacity:1;visibility:visible;}',

      '#qa-modal{',
        'background:#fff;border-radius:16px;',
        'width:100%;max-width:760px;max-height:90vh;overflow:hidden;',
        'display:flex;position:relative;',
        'transform:scale(0.94) translateY(12px);',
        'transition:transform 320ms cubic-bezier(0.34,1.3,0.64,1);',
        'box-shadow:0 24px 80px rgba(0,0,0,0.22);',
      '}',
      '#qa-overlay.qa-open #qa-modal{transform:scale(1) translateY(0);}',

      '#qa-modal-img-wrap{',
        'width:46%;flex-shrink:0;',
        'background:#f4f4f2;overflow:hidden;min-height:400px;',
      '}',
      '#qa-modal-img-wrap img{width:100%;height:100%;object-fit:cover;display:block;}',

      '#qa-modal-content{',
        'flex:1;display:flex;flex-direction:column;',
        'padding:36px 32px 28px;overflow-y:auto;',
      '}',

      '#qa-close{',
        'position:absolute;top:14px;right:14px;',
        'width:32px;height:32px;border-radius:50%;',
        'border:1px solid #e5e5e5;background:#fff;',
        'cursor:pointer;display:flex;align-items:center;justify-content:center;',
        'color:#555;font-size:20px;line-height:1;z-index:1;',
        'transition:background 0.15s,color 0.15s;font-family:inherit;',
      '}',
      '#qa-close:hover{background:#111;color:#fff;border-color:#111;}',

      '#qa-modal-title{font-size:22px;font-weight:700;letter-spacing:-0.01em;color:#111;margin:0 0 8px;line-height:1.2;}',
      '#qa-modal-price{font-size:16px;color:#111;margin:0 0 24px;display:flex;align-items:baseline;gap:8px;}',
      '#qa-modal-price .qa-compare{font-size:14px;color:#999;text-decoration:line-through;}',

      '.qa-opt-label{font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;color:#888;margin-bottom:10px;}',

      '#qa-variants{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:28px;}',
      '.qa-var-btn{',
        'padding:9px 18px;border:1.5px solid #d5d5d5;border-radius:8px;',
        'background:#fff;font-family:inherit;font-size:13px;font-weight:500;',
        'cursor:pointer;color:#111;transition:all 0.15s;min-width:48px;text-align:center;',
      '}',
      '.qa-var-btn:hover{border-color:#111;}',
      '.qa-var-btn.qa-selected{background:#111;border-color:#111;color:#fff;}',
      '.qa-var-btn:disabled{opacity:0.35;cursor:not-allowed;text-decoration:line-through;}',

      '#qa-bottom{margin-top:auto;padding-top:16px;display:flex;flex-direction:column;gap:10px;}',
      '#qa-qty-row{display:flex;align-items:center;gap:10px;}',

      '#qa-qty{display:flex;align-items:center;border:1.5px solid #e0e0e0;border-radius:10px;overflow:hidden;flex-shrink:0;}',
      '#qa-qty button{width:38px;height:46px;border:none;background:none;cursor:pointer;font-size:18px;color:#111;display:flex;align-items:center;justify-content:center;transition:background 0.15s;font-family:inherit;}',
      '#qa-qty button:hover{background:#f4f4f4;}',
      '#qa-qty-val{width:36px;text-align:center;font-size:14px;font-weight:500;color:#111;border:none;outline:none;font-family:inherit;}',

      '#qa-atc{',
        'flex:1;height:46px;background:#111;color:#fff;border:none;border-radius:10px;',
        'font-family:inherit;font-size:13px;font-weight:600;letter-spacing:0.06em;cursor:pointer;',
        'display:flex;align-items:center;justify-content:center;gap:8px;',
        'transition:background 0.2s,transform 0.15s;',
      '}',
      '#qa-atc:hover{background:#333;}',
      '#qa-atc:active{transform:scale(0.97);}',
      '#qa-atc:disabled{opacity:0.5;cursor:not-allowed;}',
      '#qa-atc.qa-success{background:#1a6641;}',

      '#qa-bin{width:100%;height:46px;background:#111;color:#fff;border:none;border-radius:10px;font-family:inherit;font-size:13px;font-weight:600;letter-spacing:0.06em;cursor:pointer;transition:background 0.2s;}',
      '#qa-bin:hover{background:#333;}',

      '#qa-notice{font-size:12px;color:#c0392b;min-height:18px;text-align:center;}',

      '@media(max-width:600px){',
        '#qa-modal{flex-direction:column;max-height:92vh;}',
        '#qa-modal-img-wrap{width:100%;min-height:200px;max-height:240px;}',
        '#qa-modal-content{padding:20px 18px 18px;}',
      '}',

    ].join('');
    document.head.appendChild(s);
  }

  /* ════════════════════════════════════════════════════════════
     MODAL
  ════════════════════════════════════════════════════════════ */
  function buildModal() {
    if (document.getElementById('qa-overlay')) return;
    var o = document.createElement('div');
    o.id = 'qa-overlay';
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.innerHTML = [
      '<div id="qa-modal">',
        '<button id="qa-close" type="button" aria-label="Close">×</button>',
        '<div id="qa-modal-img-wrap"><img id="qa-modal-img" src="" alt=""></div>',
        '<div id="qa-modal-content">',
          '<h2 id="qa-modal-title"></h2>',
          '<div id="qa-modal-price"></div>',
          '<div class="qa-opt-label" id="qa-opt-label" style="display:none"></div>',
          '<div id="qa-variants"></div>',
          '<div id="qa-bottom">',
            '<div id="qa-qty-row">',
              '<div id="qa-qty">',
                '<button id="qa-qty-minus" type="button" aria-label="Decrease">−</button>',
                '<span id="qa-qty-val">1</span>',
                '<button id="qa-qty-plus"  type="button" aria-label="Increase">+</button>',
              '</div>',
              /* ATC button uses your header bag icon */
              '<button id="qa-atc" type="button">',
                HEADER_BAG_SVG,
                '<span id="qa-atc-lbl">Add to cart</span>',
              '</button>',
            '</div>',
            '<button id="qa-bin" type="button">Buy it now</button>',
            '<div id="qa-notice"></div>',
          '</div>',
        '</div>',
      '</div>',
    ].join('');
    document.body.appendChild(o);
    bindModal();
  }

  var _qty = 1;
  var _vid = null;

  function bindModal() {
    document.getElementById('qa-overlay').addEventListener('click', function (e) {
      if (e.target.id === 'qa-overlay') closeModal();
    });
    document.getElementById('qa-close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    document.getElementById('qa-qty-minus').addEventListener('click', function () {
      if (_qty > 1) { _qty--; document.getElementById('qa-qty-val').textContent = _qty; }
    });
    document.getElementById('qa-qty-plus').addEventListener('click', function () {
      _qty++; document.getElementById('qa-qty-val').textContent = _qty;
    });

    document.getElementById('qa-atc').addEventListener('click', function () {
      if (!_vid) { notice('Please select a size'); return; }
      var btn = document.getElementById('qa-atc');
      var lbl = document.getElementById('qa-atc-lbl');
      btn.disabled = true;
      ajaxAdd(_vid, _qty, function (ok) {
        if (ok) {
          btn.classList.add('qa-success'); lbl.textContent = 'Added ✓';
          setTimeout(function () {
            window.location.href = '/cart';
          }, 900);
        } else { btn.disabled = false; }
      });
    });

    document.getElementById('qa-bin').addEventListener('click', function () {
      if (!_vid) { notice('Please select a size'); return; }
      var binBtn = document.getElementById('qa-bin');
      binBtn.disabled = true;
      binBtn.textContent = 'Redirecting…';
      ajaxAdd(_vid, _qty, function (ok) {
        if (ok) {
          window.location.href = '/checkout';
        } else {
          binBtn.disabled = false;
          binBtn.textContent = 'Buy it now';
        }
      });
    });
  }

  function openModal() {
    _qty = 1;
    document.getElementById('qa-qty-val').textContent = '1';
    notice('');
    document.getElementById('qa-overlay').classList.add('qa-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    document.getElementById('qa-overlay').classList.remove('qa-open');
    document.body.style.overflow = '';
    _vid = null;
  }

  function notice(msg) {
    var el = document.getElementById('qa-notice');
    if (el) el.textContent = msg;
  }

  /* ════════════════════════════════════════════════════════════
     POPULATE MODAL
  ════════════════════════════════════════════════════════════ */
  function populateModal(product) {
    _vid = null;
    document.getElementById('qa-modal-title').textContent = product.title;
    document.getElementById('qa-modal-img').src = product.featured_image || '';
    document.getElementById('qa-modal-img').alt = product.title;

    var priceEl = document.getElementById('qa-modal-price');
    var fv = product.variants[0];
    var p  = fmt(fv.price);
    var c  = fv.compare_at_price && fv.compare_at_price > fv.price ? fmt(fv.compare_at_price) : null;
    priceEl.innerHTML = '<span>' + p + '</span>' + (c ? '<span class="qa-compare">' + c + '</span>' : '');

    var varEl = document.getElementById('qa-variants');
    var lblEl = document.getElementById('qa-opt-label');
    varEl.innerHTML = '';

    var simple = product.variants.length === 1 &&
                 product.options.length === 1 &&
                 product.options[0].name.toLowerCase() === 'title';

    if (simple) {
      _vid = product.variants[0].id;
      lblEl.style.display = 'none';
    } else {
      lblEl.textContent   = product.options[0] ? product.options[0].name : 'Option';
      lblEl.style.display = 'block';

      product.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type        = 'button';
        b.className   = 'qa-var-btn';
        b.textContent = v.option1;
        b.dataset.vid = v.id;
        b.dataset.p   = v.price;
        b.dataset.c   = v.compare_at_price || 0;
        if (!v.available) b.disabled = true;

        b.addEventListener('click', function () {
          varEl.querySelectorAll('.qa-var-btn').forEach(function (x) { x.classList.remove('qa-selected'); });
          b.classList.add('qa-selected');
          _vid = parseInt(b.dataset.vid, 10);
          var vp = fmt(parseInt(b.dataset.p, 10));
          var vc = parseInt(b.dataset.c, 10) > parseInt(b.dataset.p, 10) ? fmt(parseInt(b.dataset.c, 10)) : null;
          priceEl.innerHTML = '<span>' + vp + '</span>' + (vc ? '<span class="qa-compare">' + vc + '</span>' : '');
          notice('');
        });
        varEl.appendChild(b);
      });
    }

    openModal();
  }

  /* ════════════════════════════════════════════════════════════
     HELPERS
  ════════════════════════════════════════════════════════════ */
  function fmt(cents) {
    if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents, '{{amount}}');
    return CFG.currencySymbol + (cents / 100).toFixed(2);
  }

  var _cache = {};
  function fetchProduct(handle, cb) {
    if (_cache[handle]) { cb(_cache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { _cache[handle] = d; cb(d); })
      .catch(function () { cb(null); });
  }

  function ajaxAdd(vid, qty, cb) {
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: vid, quantity: qty }),
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { refreshCount(); cb(true); })
      .catch(function () { notice('Could not add to cart — please try again.'); cb(false); });
  }

  function refreshCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;

        var SELECTORS = [
          '.cart-count-bubble span[aria-hidden]',
          '.cart-count-bubble',
          '[data-cart-count]',
          '.js-cart-count',
          '#cart-icon-bubble span',
          '.header__icon--cart .visually-hidden ~ span',
          'a[href="/cart"] .count',
          '.cart__count',
          '.cart-item-count',
          '[data-cart-item-count]',
        ].join(',');

        document.querySelectorAll(SELECTORS).forEach(function (el) {
          el.textContent = n;
          if (n > 0) {
            el.removeAttribute('hidden');
            el.style.display = '';
          }
        });

        var headerSection = document.querySelector('[data-section-type="header"],[data-section-id]');
        var sectionId = headerSection ? headerSection.dataset.sectionId : null;

        if (sectionId) {
          fetch('/?sections=' + sectionId)
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (!data[sectionId]) return;
              var tmp = document.createElement('div');
              tmp.innerHTML = data[sectionId];
              var newBubble = tmp.querySelector('.cart-count-bubble');
              var oldBubble = document.querySelector('.cart-count-bubble');
              if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
            })
            .catch(function () { /* silent */ });
        }

        document.dispatchEvent(new CustomEvent('cart:updated',    { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:refresh',    { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('theme:cart:add',  { detail: { cart: cart } }));
      });
  }

  function getHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  /* ════════════════════════════════════════════════════════════
     INJECT BUTTON
  ════════════════════════════════════════════════════════════ */
  function injectButton(card) {
    if (card.querySelector('.qa-btn-wrap')) return;
    var handle = getHandle(card);
    if (!handle) return;

    var inner = card.querySelector(INNER_SEL);
    if (!inner) inner = card;

    var wrap = document.createElement('div');
    wrap.className = 'qa-btn-wrap';

    var btn = document.createElement('button');
    btn.type      = 'button';
    btn.className = 'qa-btn';
    btn.setAttribute('aria-label', 'Quick add to cart');
    btn.innerHTML = '<span class="qa-btn__icon">' + BAG_PLUS_SVG + '</span>' +
                   '<span class="qa-btn__label">Choose</span>';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      handleClick(handle, btn);
    });

    btn.addEventListener('touchend', function (e) {
      if (!btn.classList.contains('expanded')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        btn.classList.add('expanded');
      }
    }, { passive: false });

    wrap.appendChild(btn);
    inner.appendChild(wrap);
  }

  /* ════════════════════════════════════════════════════════════
     HANDLE CLICK
  ════════════════════════════════════════════════════════════ */
  var _busy = new WeakSet();

  function handleClick(handle, btn) {
    if (_busy.has(btn)) return;
    _busy.add(btn);
    setTimeout(function () { _busy.delete(btn); }, 1500);

    fetchProduct(handle, function (product) {
      if (!product) { _busy.delete(btn); return; }

      var simple = product.variants.length === 1 &&
                   product.options.length === 1 &&
                   product.options[0].name.toLowerCase() === 'title';

      if (simple) {
        ajaxAdd(product.variants[0].id, 1, function (ok) { if (ok) setSuccess(btn); });
      } else {
        populateModal(product);
      }
    });
  }

  function setSuccess(btn) {
    var icon  = btn.querySelector('.qa-btn__icon');
    var label = btn.querySelector('.qa-btn__label');
    btn.classList.add('qa-success', 'expanded');
    icon.innerHTML    = CHECK_SVG;
    label.textContent = 'Added';
    setTimeout(function () {
      btn.classList.remove('qa-success', 'expanded');
      icon.innerHTML    = BAG_PLUS_SVG;
      label.textContent = 'Choose';
    }, CFG.successResetDelay);
  }

  /* ════════════════════════════════════════════════════════════
     SCAN + OBSERVE
  ════════════════════════════════════════════════════════════ */
  function scan() {
    document.querySelectorAll(CARD_SEL).forEach(injectButton);
  }

  function observe() {
    var t;
    new MutationObserver(function (muts) {
      if (!muts.some(function (m) { return m.addedNodes.length; })) return;
      clearTimeout(t); t = setTimeout(scan, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() { injectStyles(); buildModal(); scan(); observe(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();